import DataType from '@opsbase/lib-datatype/DataType/DataType';
import i18n from '@opsbase/lib-i18n';
import { DefaultOpTypeKeys } from '@opsbase/lib-op/OpType/OpType';
import Pages from '@opsbase/lib-pages';
import Validator from '@opsbase/lib-validator';
import useQuestionSetCreate from '@opsbase/react-gql-hooks/questionset/useQuestionSetCreate';
import useNewDataActions from '@opsbase/web-ctrl-newdata/useNewDataActions';
import CreateDialog from '@opsbase/web-dialogs/CreateDialog';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Pane from '@opsbase/web-layout/Pane';
import useNav from '@opsbase/web-nav/useNav';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import OpTypePicker from '@opsbase/web-pickers/OpTypePicker/OpTypePicker';
import TextFieldWithStateAndBlur from '@opsbase/web-textfield/TextFieldWithStateAndBlur/TextFieldWithStateAndBlur';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback, useState } from 'react';
export function QuestionSetCreateDialog() {
    const { raise } = useNotificationActions();
    const { addItemsToType } = useNewDataActions();
    const createQuestionSet = useQuestionSetCreate();
    const [title, setTitle] = useState('');
    const [type, setType] = useState(DefaultOpTypeKeys.UNSPECIFIED);
    const { replaceTo } = useNav();
    const handleCreate = useCallback(() => raise(createQuestionSet({ patch: { title, type } }).then(i => addItemsToType(DataType.QUESTIONSET, [i])), i18n.t('questionset-created-successful')), [raise, createQuestionSet, title, type, addItemsToType]);
    const handleChangeTitle = useCallback(newTitle => setTitle(newTitle), []);
    const handleChangeOpType = useCallback(newType => setType(newType), []);
    const handleAfterCreate = useCallback(questionSets => replaceTo(Pages.QUESTION_SETS_EDIT, { id: questionSets[0].id }), [replaceTo]);
    return (React.createElement(CreateDialog, { open: true, valid: !!title && !!type, title: i18n.t('question-set'), onCreate: handleCreate, afterCreate: handleAfterCreate },
        React.createElement(Horizontal, { centered: true },
            React.createElement(Text, null, i18n.t('questionset-type-description')),
            React.createElement(OpTypePicker, { style: { minWidth: 200 }, white: true, value: type, onChange: handleChangeOpType })),
        React.createElement(Pane, null,
            React.createElement(TextFieldWithStateAndBlur, { label: i18n.t('title'), white: true, fullWidth: true, autoFocus: true, value: title, validator: Validator.schemas().title, onChange: handleChangeTitle }))));
}
export default QuestionSetCreateDialog;
